import { render, staticRenderFns } from "./businessGood.vue?vue&type=template&id=51fe1354&scoped=true&"
import script from "./businessGood.vue?vue&type=script&lang=js&"
export * from "./businessGood.vue?vue&type=script&lang=js&"
import style0 from "./businessGood.vue?vue&type=style&index=0&id=51fe1354&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe1354",
  null
  
)

export default component.exports